// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a06e620f","455":"ab382896","977":"23641884"}[chunkId] + ".chunk.js";
};